module.exports = __webpack_public_path__ + "img/cart-list-bg.9886d2dd.png";